import { defineStore } from 'pinia';
import { AgreementFilter, AgreementStatus, AgreementType, IAgreement } from '@cyber-range/cyber-range-api-agreement-client';
import { useApiClientStore } from './apiClientStore';
import { useCompetitionStore } from './competitionStore';
import { useSessionStore } from './sessionStore';

export const useAgreementStore = defineStore('agreementStore', {
    state: () =>
    ({
        pendingAgreements: [] as IAgreement[]
    }),

    getters:
    {
        hasPendingAgreements: (state): boolean => state.pendingAgreements.length > 0,

        currentAgreement: (state): IAgreement | undefined => state.pendingAgreements[0]
    },

    actions:
    {
        async checkForPendingAgreements(): Promise<boolean>
        {
            const competitionId = useCompetitionStore().currentCompetition?.id;
            const client = useApiClientStore().backgroundAgreementApiClient;
            const response = await client.getMyAgreements(new AgreementFilter({
                type: AgreementType.CTF,
                scope: competitionId,
                status: AgreementStatus.Pending
            }));
            this.pendingAgreements = response.items;

            return this.hasPendingAgreements;
        },

        async fetchAgreementContent(agreementId: string): Promise<void>
        {
            const client = useApiClientStore().backgroundAgreementApiClient;
            const fullAgreement = await client.getOne(agreementId);
            const agreement = this.pendingAgreements.find(a => a.agreementId === agreementId);

            if (agreement)
            {
                agreement.content = fullAgreement.content;
            }
        },

        async acceptCurrentAgreement(): Promise<void>
        {
            const agreement = this.pendingAgreements[0];

            if (!agreement)
            {
                return;
            }

            const identityId = useSessionStore().session?.userId ?? '';
            const client = useApiClientStore().agreementApiClient;
            await client.accept(identityId, agreement.agreementId);

            this.pendingAgreements.splice(0, 1);
        }
    }
});
